module.exports = __webpack_public_path__ + "static/media/go-big-go-home-large-cta-mobile.ddb033df.jpg";